import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout file for /setup/departments/* — exists so the index route (the list)
// and the $id route (the detail) can both nest under a common parent.
// Currently no shared chrome; just renders the matched child.
export const Route = createFileRoute('/_authenticated/setup/departments')({
  component: () => <Outlet />,
});
